<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center min-vh-100 p-3 text-center"
    style="background-color: #f8f9fa"
  >
    <h1>404</h1>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true" />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        showLoading: false,
      }
    },
  }
</script>

<style scoped></style>
